import {filter} from 'rxjs/operators';
import {toWsMsg$, wsMsg$} from '@/ws';
import {wsLogin$, wsLogout$} from '@/user/auth-ws';
import LaunchPoolMsg = lp.LaunchPoolMsg;

wsLogin$.subscribe(() => toWsMsg$.next({method: 'service.subscribe', params: ['service.launchpool']}));
wsLogout$.subscribe(() => toWsMsg$.next({method: 'service.unsubscribe', params: ['service.launchpool']}));

export const launchPoolMsg$ = wsMsg$.pipe(filter((o: LaunchPoolMsg) => o.msgType === 'launch.pool.assets'));
